module.exports = __webpack_public_path__ + "img/permission-delete.a28c6b53.png";